import React from 'react';
import DatePicker from 'react-datepicker';
import { Portal } from 'react-overlays';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import CustomDateInput from './CustomDateInput';

class CaspianDatePicker extends React.Component {
  static defaultProps = {
    selected: new Date(),
    allowIndefinite: false,
    onChange: () => alert('Empty function'),
    labelText: '',
    // When true, the picker operates purely on the calendar day and never
    // re-interprets the wall-clock time as UTC. This keeps the displayed and
    // returned date identical in every timezone (UTC-minus, UTC and UTC-plus),
    // which is what the backend's date-only / UTC-midnight columns expect.
    utc: false,
  };

  constructor(props) {
    super(props);
    let firstSelectedDate = props.selected;

    this.state = {
      selectedDate: firstSelectedDate,
      labelText: props.labelText,
      indefinite: dateTimeHelper.isIndefinite(firstSelectedDate),
      prevSelectedDate: new Date(),
    };
  }

  CalendarContainer = ({ children }) => {
    const el = document.getElementById('calendar-portal');
    return <Portal container={el}>{children}</Portal>;
  };

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (
      !isNaN(this.props.selected) &&
      (this.props.selected !== prevProps.selected ||
        dateTimeHelper.toYYYYsMMsDD(this.props.selected) !== dateTimeHelper.toYYYYsMMsDD(prevProps.selected))
    ) {
      this.setState({
        selectedDate: typeof this.props.selected === 'string' ? Date.parse(this.props.selected) : this.props.selected,
        indefinite: dateTimeHelper.isIndefinite(this.props.selected),
      });
    }
  }

  renderIndefiniteCheckBox() {
    if (!this.props.allowIndefinite) {
      return null;
    }

    return (
      <>
        <span>
          <input
            className='ml-1 mr-1'
            type='checkBox'
            checked={this.state.indefinite}
            onChange={(e) => {
              var newIndefinite = !this.state.indefinite;
              var selDate = newIndefinite ? dateTimeHelper.indefiniteDateValue() : this.state.prevSelectedDate;
              var prevSelDate = this.state.selectedDate;
              this.setState({
                indefinite: e.target.checked,
                selectedDate: selDate,
                prevSelectedDate: prevSelDate,
              });
              this.props.onChange(selDate);
            }}
          />
        </span>
        <span className='w-25'>&nbsp;&nbsp;</span>
      </>
    );
  }

  render() {
    let sel = this.state.selectedDate ? this.state.selectedDate : new Date();
    sel = new Date(sel);

    if (isNaN(sel.getTime())) {
      //react-datepicker formats `selected` with date-fns, which throws 'Invalid time value' on an
      //unparsable date - and that takes the whole page down through the error boundary. Falling back
      //to today keeps the field (and the panel around it) usable (CD-5517).
      sel = new Date();
    }

    if (this.props.utc) {
      //Display the calendar day as-is (local midnight), independent of timezone.
      sel = new Date(sel.getFullYear(), sel.getMonth(), sel.getDate());
    } else if (sel.getHours() !== 0) {
      //If hour component is not 0, the date is more than likely in locale time, so convert it to UTC
      sel = new Date(sel.getTime() + sel.getTimezoneOffset() * 60000);
    }

    return (
      <>
        {this.state.labelText !== '' && (
          <>
            <label htmlFor='caspiandatepicker'>{this.state.labelText}</label>
            <br />
          </>
        )}
        <span className='ds-datefield'>
          {this.renderIndefiniteCheckBox()}
          {
            !this.state.indefinite ? (
              <DatePicker
                name='caspiandatepicker'
                className=' initialism '
                selected={sel}
                onChange={(e) => {
                  //react-datepicker emits a local-midnight Date for the picked calendar day.
                  //In utc mode pass that day straight through; re-interpreting the wall-clock as
                  //UTC (the legacy path) makes the date slip to the previous day in UTC-minus zones.
                  const date = this.props.utc
                    ? new Date(e.getFullYear(), e.getMonth(), e.getDate())
                    : dateTimeHelper.convertUTCDateStringToLocale(e);
                  this.setState({
                    selectedDate: date,
                  });
                  this.props.onChange(date);
                }}
                disabledNavigation
                calendarClassName='ds-datecal'
                customInput={<CustomDateInput />}
                showMonthDropdown
                showYearDropdown
                todayButton='Today'
                id={'caspiandatepicker'}
                popperContainer={this.CalendarContainer}
                popperPlacement='top-start'
                popperModifiers={{
                  //popper v1 syntax (react-datepicker 3.8 → react-popper 1.x). Without this the
                  //calendar keeps its flipped bottom placement on zoomed/short viewports and runs
                  //off-screen; shifting within the viewport keeps it fully visible instead.
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                    boundariesElement: 'viewport',
                  },
                }}
              />
            ) : (
              <span className='ds-dateindefinite'>&#8734;</span>
            ) //indefinite symbol
          }
        </span>
      </>
    );
  }
}

export default CaspianDatePicker;
